<template>
  <div class="detail" :class="{hidden:category.IsHidden}">
    <div :id="category.Category.UniqueCategoryName" class="detailHead">
      <img src="../assets/img/marketing standard.svg" class="iconMark" /> {{category.Category.CategoryName}}
    </div>
    <report v-for="(report, index) in reports" :report="report" :key="report.ReportId" :color="color"></report>
  </div>
</template>
<style scoped>
.iconMark {
  margin-right: 10px;
  width: 22px;
  height: 22px;
}

.detail {
  float: left;
  width: 100%;
  margin-top: 40px;
}

.detailHead {
  width: 100%;
  padding-bottom: 10px;
  float: left;
  text-align: left;
  font-size: 16px;
  font-family: "HelveticaNeue-Medium";
  color: #5c5c5c;
  border-bottom: 1px solid #cbcccc;
}
</style>
<script>
import report from "./Report.vue";
export default {
  props: ["category", "color"],
  components: { report },
  computed: {
    reports: function() {
      var reportArray = [];
      for (let index in this.category.Reports) {
        let reportData = this.category.Reports[index];
        let urlPre = "report?path=";
        switch (reportData.ReportType.toUpperCase()) {
          case "SSRS".toUpperCase():
            urlPre = "report?path=";
            break;
          case "DashBoard".toUpperCase():
            urlPre = reportData.UseFilter =='1' ? "tableau2?path=" : "tableau?path=";
            break;
          case "SelfService".toUpperCase():
            urlPre = "customize?path=";
        }

        if(reportData.Mode == "edit"){
          urlPre = "customize?path=";
        }

        reportData.Url = urlPre + reportData.ReportPath;
      }

      for (let i = 0; i < this.category.Reports.length; i++) {
        let report = this.category.Reports[i];
        report.IsPlaceHolder = false;
        reportArray.push(report);
        if ((i + 1) % 3 === 0) {
          reportArray.push({
            IsPlaceHolder: true
          });
        }
      }
      return reportArray;
    }
  }
};
</script>


// WEBPACK FOOTER //
// ReportCategory.vue?60e82b1d